import React, { useState } from "react";
import "../login/Login.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash, FaUser, FaLock } from "react-icons/fa";
import API_BASE_URL from "../config";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const details = {
        'Email': email,
        'Password': password
      };

      const formBody = Object.keys(details)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(details[key]))
        .join('&');

      console.log("Attempting Login with Form Data to:", `${API_BASE_URL}/api/login`);

      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formBody
      });

      const text = await response.text();
      console.log("Raw Response Text:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = {};
      }

      if (response.ok && (data.success || data.user || data.data || data.token || data.id)) {
        const user = data.user || data.data || (data.id ? data : null);

        if (user) {
          let rawRole = user.role || user.A_Role || user.employee_role || "employee";
          let role = "employee";
          if (rawRole === "admin" || rawRole === "A") role = "admin";
          else if (rawRole === "manager" || rawRole === "M") role = "manager";

          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("role", role);

          toast.success("Login successful!");

          setTimeout(() => {
            if (role === "admin") {
              navigate("/admindashboard");
            } else {
              navigate("/dashboard");
            }
          }, 1000);
        } else {
          toast.error("User data missing.");
        }
      } else {
        toast.error("Invalid credentials");
      }
    } catch (error) {
      console.error("Login Error:", error);
      toast.error("Connection failed. Check your internet or Server CORS.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer />
      <div className="login-card-outer">
        <div className="login-card-inner">

          <div className="logo-section">
            <img src="./images/Logo New (1).png" alt="Align Desk" className="brand-logo" />
            <p className="auth-subtitle">AUTHENTICATION</p>
          </div>

          <div className="welcome-header">
            <h2 className="welcome-title">Welcome Back</h2>
            <p className="welcome-subtitle">Log in to access your account</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-wrapper">
              <FaUser className="input-icon" />
              <input
                type="text"
                placeholder="admin@aligndesk.io"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="input-wrapper">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="•••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={togglePasswordVisibility}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? "Loading..." : "Log In ➔"}
            </button>
          </form>



          {/* Designed By Section */}
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", marginTop: "25px" }}>
            <span style={{ fontSize: "12px", color: "rgba(255,255,255,0.5)", letterSpacing: "0.5px" }}>Designed and Developed by </span>
            <a href="https://hjsysweb.com/" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center" }}>
              <img src="/hjfabicon.png" alt="HJ Logo" style={{ height: "18px", objectFit: "contain", opacity: 0.8, cursor: "pointer" }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
